import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
`;

export const Badge = styled.span`
  position: absolute;
  top: ${({ theme }) => theme.yoga.spacing.zero};
  right: ${({ theme }) => theme.yoga.spacing.zero};
  min-width: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  min-height: ${({ theme }) => theme.yoga.spacing.xxsmall}px;
  border-radius: 10px;
  background-color: ${({ theme }) => theme.yoga.colors.error};
  color: ${({ theme }) => theme.yoga.colors.white};
  z-index: 1;
  display: flex;
  font-size: ${({ theme }) => theme.yoga.fontSizes.xxsmall}px;
  justify-content: center;
  align-items: center;
  font-weight: ${({ theme }) => theme.yoga.fontWeights.medium};
  padding: 2px ${({ theme }) => theme.yoga.spacing.xxxsmall}px;
  line-height: 1;
  transform: translate(50%, -50%);
`;
